import React from "react";
import { Card, Col, Container, Row } from "react-bootstrap";
import TypeWriterEffect from "react-typewriter-effect";
import Fade from "react-reveal/Fade";
import pic1 from "../../../Images/pic1.png";

const About = () => {
  return (
    <div id="about" className="  my-4 py-5">
      <Container className="py-5 border-1 about-card">
        <Row xs={1} md={2} className="g-4 py-5 align-items-center ">
          <Col>
            <Fade left>
              <img className="w-75" src={pic1} alt="" />
            </Fade>
          </Col>
          <Col>
            <Card className="about-card">
              <Card.Body className="text-start">
                <Card.Title className="pb-4 fs-2">
                  <TypeWriterEffect
                    textStyle={{
                      textAlign: "start",
                    }}
                    startDelay={100}
                    cursorColor="transparent"
                    text="ABOUT-ME"
                    typeSpeed={100}
                    // scrollArea={myAppRef}
                  />
                </Card.Title>
                <Fade right>
                  <Card.Text className="fs-5" style={{ textAlign: "justify" }}>
                    I'm a front-end developer from Dhaka Bangladesh.I consider
                    myself to be a dedicated developer who enjoys coding, open
                    source, and the online platform. <br /> <br /> I create
                    responsive websites and web application using HTML, CSS, and
                    JavaScript to give users the best and most relevant
                    experience for their designated device and browser.
                  </Card.Text>
                </Fade>
              </Card.Body>
            </Card>
          </Col>
        </Row>
      </Container>
    </div>
  );
};

export default About;
